/**
 * Lightweight logger — dev'de console'a yazar, prod'da sessizdir.
 * Kullanım:
 *   import { logger } from '@/lib/logger';
 *   logger.warn('Something off', err);
 *
 * Critical hatalar için yine `console.error` veya toast.error tercih edin.
 */

const isDev = typeof import.meta !== 'undefined' && import.meta.env?.DEV;

function noop() {}

export const logger = {
  log: isDev ? console.log.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  error: isDev ? console.error.bind(console) : noop,
  debug: isDev ? (console.debug ? console.debug.bind(console) : console.log.bind(console)) : noop,
};

export default logger;
